<template>
  <AppCard :shadow="false" class="">
    <template #title>
      Laporan > Detail Laporan > Inspeksi Akhir Pekerjaan
    </template>
    <div v-if="store.loading" class="flex w-full justify-center my-5">
      <AppSpinKit :grid="true"/>
    </div>
    <div v-else class="bg-[#F4F7FC] w-full px-9 pt-4 pb-5 flex z-10 border-b-2">
      <h3 class="text-lg p-2 pr-2 font-poppins">Proyek :</h3>
      <AppHoverTitle :title="store.detail.project_name"/>
      <h3 class="text-lg p-2 pr-2 font-poppins">Tanggal Laporan :</h3>
      <h3 class="title-card">
        {{ formatTanggal(store.detail.date) }}
      </h3>
    </div>
    <AppTableHeader
        @set-active="setFilterActive"
        @search="setFilterSearch"
        @direction="setFilterDirection"
        :active="filterActive"
        :menuList="headerList"
    >
      <div class="flex gap-x-4">
        <button
            class="bg-[#65B741] py-2 px-5 text-white rounded-xl shadow-sm focus:ring-[#cdf3c0] hover:bg-[#C1F2B0] focus:ring-4 focus:outline-none inline-flex uppercase font-poppins font-semibold space-x-3"
            @click="openAddSubmitModal"
        >
          <AppIcon name="ChevronRight" classTag="m-auto h-6 w-6"/>
          <h5>Submit</h5>
        </button>
      </div>
    </AppTableHeader>
    <div v-if="store.loading" class="flex w-full justify-center my-20">
      <AppSpinKit :grid="true"/>
    </div>
    <AppTable
        v-else
        :key="store.detail.result_details"
        :headerList="headerList"
        :bodyList="store.detail.result_details"
        :action="true"
        :overflowX="true"
    >
      <template #action="{ data }">
        <button @click="toggleEditModal(data)" class="edit-button">
          <AppIcon name="Pencil" classTag="stroke-white p-1"/>
        </button>
      </template>
    </AppTable>
    <TableModal
        title="Inspeksi Akhir Pekerjaan"
        :edit="editModal"
        :erase="eraseModal"
        @edit-submit="editWorkInResult"
        @edit-close="toggleEditModal"
    >
      <div class="gap-3">
        <AppInput type="hidden" v-model="formInput.detail_id"/>
        <AppInput
            title="Pelaksanaan Scope Volume"
            v-model="formInput.scope_actual_volume"
            :isRequired="true"
        />
        <AppInput
            title="Pelaksanaan Scope Unit"
            v-model="formInput.scope_actual_unit"
            :isRequired="true"
        />
        <AppInput title="Keterangan" v-model="formInput.description"/>
      </div>
    </TableModal>
    <!-- submit modal -->
    <AppModal :isOpen="submitModal">
      <template #title>
        <AppModalCloseButton
            title="Submit Inspeksi Pelaksanaan Pekerjaan"
            @close="submitModal = false"
        />
      </template>
      <form @submit.prevent="submitWorkInResult">
        <div class="gap-3">
          <AppInput title="Form" v-model="submitForm.form"/>
          <AppInput title="Nomor" v-model="submitForm.number"/>
          <AppInput title="Halaman" v-model="submitForm.page"/>
        </div>
        <div class="mt-8 flex items-stretch">
          <button type="submit" class="form-button">Submit</button>
        </div>
      </form>
    </AppModal>
  </AppCard>
</template>
<script setup>
import AppCard from "@/components/AppCard.vue";
import AppHoverTitle from "@/components/AppHoverTitle.vue";
import AppIcon from "@/components/AppIcon.vue";
import AppInput from "@/components/AppInput.vue";
import AppModal from "@/components/AppModal.vue";
import AppModalCloseButton from "@/components/AppModalCloseButton.vue";
import AppSpinKit from "@/components/AppSpinKit.vue";
import AppTable from "@/components/AppTable.vue";
import AppTableHeader from "@/components/AppTableHeader.vue";
import TableModal from "@/components/TableModal.vue";
import useFilter from "@/composable/useFilter";
import useModal from "@/composable/useModal";
import {formatTanggal} from "@/helper/tanggal";
import {useReportStore} from "@/store/report";
import {ref} from "vue";
import {useRouter} from "vue-router";

const store = useReportStore();
const router = useRouter();

const {
  filterActive,
  setFilterActive,
  setFilterDirection,
  setFilterSearch,
} = useFilter();

const {formInput, editModal, eraseModal, toggleEditModal} = useModal();

const headerList = [
  {
    classTag: " min-w-[4rem] sticky left-0 ",
    title: "Nomor",
    id: "order_number",
  },
  {
    classTag:
        " text-left sticky min-w-[19rem] sticky left-[5.4rem] border-r-2 mr-8",
    title: "Title",
    id: "scope_title",
  },
  {
    classTag: "text-center w-48",
    title: "Penawaran Scope Volume",
    id: "scope_plan_volume",
  },
  {
    classTag: "text-center w-44",
    title: "Penawaran Scope Unit",
    id: "scope_plan_unit",
  },
  {
    classTag: "text-center w-48",
    title: "Pelaksanaan Scope Volume",
    id: "scope_actual_volume",
  },
  {
    classTag: "text-center w-44 ",
    title: "Pelaksanaan Scope Unit",
    id: "scope_actual_unit",
  },
  {
    classTag: "text-center ",
    title: "Keterangan",
    id: "description",
  },
];

const submitModal = ref(false);
const submitForm = ref({
  form: "",
  number: "",
  page: "",
});

async function editWorkInResult() {
  store.$patch({
    detail: {
      ...store.detail,
      result_details: store.detail.result_details.map((item) => {
        if (item.id === formInput.value.id) {
          return {
            ...item,
            scope_actual_volume: formInput.value.scope_actual_volume,
            scope_actual_unit: formInput.value.scope_actual_unit,
            description: formInput.value.description,
          }
        }
        return item;
      }),
    }
  });
  formInput.value = {};
  editModal.open = false;
}

async function submitWorkInResult() {
  const data = {
    ...submitForm.value,
    details: store.detail.result_details.map((item) => {
      return {
        detail_id: item.id,
        scope_actual_volume: item.scope_actual_volume,
        scope_actual_unit: item.scope_actual_unit,
        description: item.description,
      }
    })
  };
  await store.submitReport(store.detail.id, store.detail.report_type, data);
  router.back();
}

const openAddSubmitModal = () => {
  submitModal.value = true;
  submitForm.value.form = store.detail.form;
  submitForm.value.page = store.detail.page;
  submitForm.value.number = store.detail.number;
}
</script>
<style scoped>
.title-card {
  @apply bg-[#DAE1EC] text-lg p-2 font-poppins rounded-md text-center;
}

.form-button {
  @apply bg-blue-500 hover:bg-blue-500/50 hover:shadow-lg w-full p-1.5 rounded-lg text-sm text-white uppercase focus:ring-4 focus:ring-blue-200;
}

.edit-button {
  @apply bg-yellow-500 rounded-xl focus:ring-yellow-200 hover:bg-yellow-400 focus:ring-4 focus:outline-none;
}
</style>
